import type { Epicycle } from "../math/epicycles";
import { fourierConfig as config } from "../config";

type Props = {
  chain: readonly Epicycle[];
  opacity?: number;
  scale?: number;
  minRadius?: number;
  colors?: { circle: string; vector: string };
};
export const EpicycleChain = ({
  chain,
  opacity = 1,
  scale = config.layout.scale,
  minRadius = config.minCircleRadius,
  colors = config.colors,
}: Props) => (
  <g opacity={opacity} fill="none">
    {chain.map((c, i) => {
      const radius = c.radius * scale;
      return (
        <g key={c.frequency}>
          {config.showCircles && radius >= minRadius && (
            <circle
              cx={c.center.x}
              cy={c.center.y}
              r={c.radius}
              stroke={colors.circle}
              strokeWidth={(radius < 7 ? 1.7 : 2) / scale}
              opacity={radius < 7 ? 0.72 : 0.45}
            />
          )}
          <line
            x1={c.center.x}
            y1={c.center.y}
            x2={c.tip.x}
            y2={c.tip.y}
            stroke={colors.vector}
            strokeWidth={1.65 / scale}
            opacity={i < 5 ? 0.66 : 0.45}
          />
          {radius >= 4 && (
            <circle
              cx={c.center.x}
              cy={c.center.y}
              r={2.3 / scale}
              fill={colors.vector}
              opacity={0.72}
            />
          )}
        </g>
      );
    })}
  </g>
);
